<!-- 拒绝弹窗 -->
<template>
    <el-dialog :title="title" :visible.sync="show" @close="$emit('input', false)" :width="width" top="50px">
        <el-form ref="formData" :model="formData" label-width="80px">
            <el-form-item label="售后商品">
                <div class="product-detail">
                    <el-image class="product-pic"
                        src="https://pic.3gbizhi.com/uploads/20240306/b084d2ca073b4bbaeb4abb42ade81630.jpg"
                        fit="fit"></el-image>
                    <div class="info">
                        <div class="info-name">发大水范德萨范德萨</div>
                        <div class="info-num">1件</div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="售后概述">
                <div class="intro-box">
                    <div class="intro-item">
                        <div class="title">类型原因：</div>
                        <div class="content">
                            范德萨发大范德萨范德萨范德萨发大发大范德萨范德萨范德萨
                        </div>
                    </div>
                    <div class="intro-item">
                        <div class="title">退款金额：</div>
                        <div class="content">¥199.00</div>
                    </div>
                </div>
            </el-form-item>

            <el-divider></el-divider>
        
            <el-form-item label="协商方案">
                <el-input v-model="formData.way"></el-input>
            </el-form-item>
            <el-form-item label="协商说明">
                <el-select v-model="formData.name" placeholder="请选择协商说明">
                    <el-option v-for="(item, index) in reasonList" :key="index" :label="item.label"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="售后类型">
                <el-radio-group v-model="formData.type">
                    <el-radio label="1">仅退款</el-radio>
                    <el-radio label="2">退款退货</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="退款金额">
                <el-input @input="onMoneyInput" type="number" :placeholder="`最多可退${maxMoney}元`" v-model="formData.money">
                    <template slot="prepend">¥</template>
                </el-input>
            </el-form-item>
            <el-form-item label="补充说明">
                <el-input type="textarea" rows="5" v-model="formData.desc"></el-input>
            </el-form-item>
            
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="show = false">取 消</el-button>
            <el-button type="primary" @click="sureFn">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { debounce } from 'lodash';
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        detail: {
            type: Object,
            default: () => { },
        },
        title: {
            type: String,
            default: "提示",
        },
        width: {
            type: String,
            default: "40%",
        },
    },
    components: {
    },
    watch: {
        value(nval) {
            this.show = nval;
        },
    },
    data() {
        return {
            show: false,
            maxMoney: '200.00', // 退款最大金额
            formData: {
                way: "",
                name: "",
                type: "1",
                money: "",
                desc: "",
                // imgs: [],
            },
            reasonList: [
                { label: "哈哈哈哈1", id: 1 },
                { label: "哈哈哈2", id: 2 },
                { label: "哈哈哈哈3", id: 3 },
            ],
        };
    },
    methods: {
        sureFn() {
            console.log("提交表单");
        },
        onMoneyInput:debounce(function (e){
            let num = (e-0).toFixed(2)
            this.formData.money = num
            if(this.maxMoney*100 < num*100){
                this.formData.money = this.maxMoney
            }
        },1000)
    },
};
</script>

<style lang="less" scoped>
.tip-box {
    display: flex;
    align-items: center;
    background: #f6f6f6;
    border-radius: 6px;
    padding: 8px 12px;
    margin-bottom: 20px;

    .detail-link {
        color: #1989fa;
        cursor: pointer;
    }
}

.product-detail {
    display: flex;

    .product-pic {
        border-radius: 6px;
        width: 100px;
        height: 100px;
    }

    .info {
        margin-left: 10px;

        .info-name {
            font-weight: 700;
        }

        .info-num {
            color: #b6b6b6;
        }
    }
}

.intro-box {
    .intro-item {
        display: flex;
    }
}
</style>